import { Button, Space, Typography } from 'antd'
import {
  PaperClipOutlined,
  DeleteOutlined,
  DownloadOutlined,
  CloseCircleFilled,
  PlusOutlined,
} from '@ant-design/icons'
import { useEffect, useRef, useState } from 'react'
import Utils, { downloadExcelFile } from 'general/utils/Utils'
import FindInvoiceModal from 'general/components/Modal/FindInvoiceModal'
import { INVOICE_TYPE_TO_QUERY } from 'general/constants/AppConstants'
import InvoiceHelper from 'general/helpers/InvoiceHelper'
import FindInvoiceModalTradeDiscount from 'general/components/Modal/FindInvoiceModalTradeDiscount'
import { useMutationViewPdf } from 'features/Invoice/screens/ListInvoice/queries'

const { Text } = Typography

export default function InvoiceTradeDiscount({ data, setData }) {
  const [dataTrandeDiscount, setDataTrandeDiscount] = useState([])
  const [findInvoiceModalShow, setFindInvoiceModalShow] = useState(false)

  const { mutate: viewPdfInvoice } = useMutationViewPdf()

  useEffect(() => {
    if (Array.isArray(data)) {
      setDataTrandeDiscount(data)
    } else if (data) {
      setDataTrandeDiscount([data])
    } else {
      setDataTrandeDiscount([])
    }
  }, [data])

  return (
    <>
      <Space wrap align="start">
        <Button
          icon={<PlusOutlined />}
          style={{ height: 40 }}
          onClick={() => {
            setFindInvoiceModalShow(true)
          }}
        >
          Chọn hóa đơn
        </Button>

        {dataTrandeDiscount.map((item, index) => (
          <div
            key={item?.invoiceId || index}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '8px 12px',
              borderRadius: 6,
            }}
          >
            <Space>
              <Text
                style={{ cursor: 'pointer' }}
                onClick={() => viewPdfInvoice(item)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = '#1677ff'
                  e.currentTarget.style.textDecoration = 'underline'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = ''
                  e.currentTarget.style.textDecoration = ''
                }}
              >
                {item?.serial} - {Utils.padString(item?.no, 8, '0')}
              </Text>
            </Space>

            <CloseCircleFilled
              style={{ color: '#ff4d4f', cursor: 'pointer', marginLeft: 5 }}
              onClick={() => {
                setDataTrandeDiscount((prev) => {
                  const newData = prev.filter((_, i) => i !== index)
                  setData(newData)
                  return newData
                })
              }}
            />
          </div>
        ))}
      </Space>

      <FindInvoiceModalTradeDiscount
        checkBoxShow={false}
        show={findInvoiceModalShow}
        onHide={() => setFindInvoiceModalShow(false)}
        title="Chọn hoá đơn là căn cứ để chiết khấu thương mại"
        invoiceType={INVOICE_TYPE_TO_QUERY.CAN_REPLACED}
        buttonAgreeVisibility={true}
        selectableRows={dataTrandeDiscount}
        setSelectableRows={(data) => {
          setDataTrandeDiscount(data)
          setData(data)
        }}
        onRowClicked={() => {}}
        buttonAgreeOnlick={async (data) => {
          const normalize = Array.isArray(data) ? data : data ? [data] : []

          const picked = normalize.map((item) => ({
            invoiceId: item.invoiceId,
            no: item.no,
            serial: item.serial,
            date: item.date,
            totalPrice: item.totalPrice,
            customerTaxCode: item.customerTaxCode,
            customerCompanyName: item.customerCompanyName,
            customerName: item.customerName,
            numberFormat: item.numberFormat,
            totalAfterTax: item.totalAfterTax,
            currency: item.currency,
          }))

          const uniqueData = Array.from(
            new Map(picked.map((item) => [item.invoiceId, item])).values(),
          )

          setData(uniqueData)
          setDataTrandeDiscount(uniqueData)
          setFindInvoiceModalShow(false)
        }}
        buttonAgreeTab2Onlick={async () => {}}
      />
    </>
  )
}
